import { format } from 'date-fns';
import { StatsDateRange } from '../admin-stats-aggregate/admin-stats-aggregate.types';

const DAY_MS = 24 * 60 * 60 * 1000;

export function formatUtcDateOnly(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function getYesterdayUtc(now = new Date()): string {
  return formatUtcDateOnly(new Date(now.getTime() - DAY_MS));
}

export function clampDateToMax(value: string, maxDate: string): string {
  if (!value) {
    return value;
  }

  return value > maxDate ? maxDate : value;
}

export function getThisWeekRangeUtc(now = new Date()): StatsDateRange {
  const endDate = formatUtcDateOnly(now);
  const day = now.getUTCDay();
  const daysSinceMonday = (day + 6) % 7;
  const monday = new Date(now.getTime() - daysSinceMonday * DAY_MS);

  return {
    startDate: formatUtcDateOnly(monday),
    endDate,
  };
}

export function getThisMonthRangeUtc(now = new Date()): StatsDateRange {
  const start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));

  return {
    startDate: formatUtcDateOnly(start),
    endDate: formatUtcDateOnly(now),
  };
}

export function formatStatsPeriodLabel(startDate: string, endDate: string): string {
  if (startDate === endDate) {
    return startDate;
  }

  return `${format(startDate, 'dd/MM/yyyy')} – ${format(endDate, 'dd/MM/yyyy')}`;
}

export function isValidStatsDateRange(startDate: string, endDate: string): boolean {
  if (!startDate || !endDate) {
    return false;
  }

  return startDate <= endDate;
}

/** Same-length UTC window immediately before the selected range. */
export function resolvePreviousStatsPeriod(startDate: string, endDate: string): StatsDateRange {
  const start = new Date(`${startDate}T00:00:00.000Z`);
  const end = new Date(`${endDate}T00:00:00.000Z`);
  const spanDays = Math.round((end.getTime() - start.getTime()) / DAY_MS) + 1;
  const previousEnd = new Date(start.getTime() - DAY_MS);
  const previousStart = new Date(previousEnd.getTime() - (spanDays - 1) * DAY_MS);

  return {
    startDate: formatUtcDateOnly(previousStart),
    endDate: formatUtcDateOnly(previousEnd),
  };
}
